import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { ArrowLeft, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { StepNav } from '@/components/verification/step-nav';
import { FlowCancelConfirmDialog } from '@/components/verification/flow-cancel-dialog';
import { ROUTES } from '@/lib/constants';
import { useEmployerVerificationStore } from '@/features/employer-verification/store';

const STEPS = [
  { to: ROUTES.employerVerificationPricing, label: 'Pricing' },
  { to: ROUTES.employerVerificationOtp, label: 'Verify identity' },
  { to: ROUTES.employerVerificationRecords, label: 'Review' },
  { to: ROUTES.employerVerificationConsent, label: 'Consent' },
  { to: ROUTES.employerVerificationConfirm, label: 'Confirm' },
];

export function EmployerVerificationLayout() {
  const reset = useEmployerVerificationStore((s) => s.reset);
  const navigate = useNavigate();
  const [cancelOpen, setCancelOpen] = useState(false);
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div className="flex items-center justify-between">
        <Button variant="ghost" size="sm" onClick={() => navigate(ROUTES.employer)}>
          <ArrowLeft className="h-4 w-4" /> Back
        </Button>
        <Button variant="ghost" size="sm" onClick={() => setCancelOpen(true)}>
          Cancel <X className="h-4 w-4" />
        </Button>
      </div>

      <StepNav steps={STEPS} />

      <Card className="p-6 sm:p-8">
        <Outlet />
      </Card>

      <FlowCancelConfirmDialog
        open={cancelOpen}
        onStay={() => setCancelOpen(false)}
        onConfirmCancel={() => {
          setCancelOpen(false);
          reset();
          navigate(ROUTES.employer, { replace: true });
        }}
        description="This will abandon company verification and clear your progress."
      />
    </div>
  );
}
